<template>
  <api-document v-if="document" :id="id" :document="document" />
</template>

<script setup lang="ts">
import { apiDataRef } from '@/utils/api';
import client from '@/api/client';
import ApiDocument from '@/components/api/ApiDocument.vue';

const props = defineProps({
  id: { type: String, required: true },
});

const document = apiDataRef(() => client.getApiDocument(props.id));
</script>
